import { SubmissionError } from 'redux-form';
import { POINT_REQUIRED_FIELDS, REQUIRED_FIELDS } from './constants';
import { goToElement } from '../../utils/goToElement';

export const transformToValidationErrors = errors => {
	goToElement(Object.keys(errors)[0]);
	return Object.entries(errors).reduce((prev, [key, error]) => {
		if (!prev[key]) {
			prev[key] = {};
		}

		if (key.includes('points') && key !== 'points') {
			const arr = key.split('.');

			if (!prev.points) {
				prev.points = {};
			}

			prev.points = {
				...prev.points,
				[arr[1]]: {
					...(prev.points[arr[1]] || {}),
					[arr[2]]: !arr[3] ? error : { error },
				},
			};
		}

		prev[key] = error;

		return prev;
	}, {});
};

const validatePoint = (values, key, index, fields) => {
	fields.forEach(field => {
		if (!values?.points?.[index]?.[field]) {
			const error = { points: [] };
			error.points[index] = { [field]: 'Заполните это поле' };
			goToElement(`${key}.${field}`);
			throw new SubmissionError(error);
		}
	});
};

export const validate = values => {
	REQUIRED_FIELDS.forEach(key => {
		if (key === 'options_points') {
			Object.keys(values?.points).forEach(idx => {
				if (values?.points[idx].is_fetch) {
					validatePoint(values, `points[${idx}]`, idx, POINT_REQUIRED_FIELDS);
				}
			});
		}

		if (!values?.[key] && !key.includes('points') && key !== 'options_points') {
			goToElement(key);
			throw new SubmissionError({ [key]: 'Заполните это поле' });
		}
	});
};
